import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

import { CartState } from "./cart.types";

const initialState = {
  open: false,
  cartItems: [],
  isCartFetching: false,
  isCartItemAdding: false,
  isCartItemRemoving: false,
  isCartItemClearing: false,
  errorOnCartFetching: null,
  errorOnCartItemAdding: null,
  errorOnCartItemRemoving: null,
  errorOnCartItemClearing: null,
} as CartState;

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    toggleCartOpen: (state) => {
      state.open = !state.open;
    },
    // Fetch cart
    fetchCartStart: (state) => {
      state.isCartFetching = true;
    },
    fetchCartSuccess: (state, action) => {
      state.cartItems = action.payload;
      state.errorOnCartFetching = null;
      state.isCartFetching = false;
    },
    fetchCartFailure: (state, action) => {
      state.errorOnCartFetching = action.payload;
      state.isCartFetching = false;
    },
    // Add item
    addItemStart: (state) => {
      state.isCartItemAdding = true;
    },
    addItemSuccess: (state, action) => {
      state.cartItems = action.payload;
      state.errorOnCartItemAdding = null;
      state.isCartItemAdding = false;
    },
    addItemFailure: (state, action) => {
      state.errorOnCartItemAdding = action.payload;
      state.isCartItemAdding = false;
    },
    // Remove item
    removeItemStart: (state) => {
      state.isCartItemRemoving = true;
    },
    removeItemSuccess: (state, action) => {
      state.cartItems = action.payload;
      state.errorOnCartItemRemoving = null;
      state.isCartItemRemoving = false;
    },
    removeItemFailure: (state, action) => {
      state.errorOnCartItemRemoving = action.payload;
      state.isCartItemRemoving = false;
    },
    // Clear item
    clearItemStart: (state) => {
      state.isCartItemClearing = true;
    },
    clearItemSuccess: (state, action) => {
      state.cartItems = action.payload;
      state.errorOnCartItemClearing = null;
      state.isCartItemClearing = false;
    },
    clearItemFailure: (state, action) => {
      state.errorOnCartItemClearing = action.payload;
      state.isCartItemClearing = false;
    },

    // removeItem: (state, action) => {
    //   state.cartItems = removeItemFromCart(state.cartItems, action.payload);
    // },
    // clearItemFromCart: (state, action) => {
    //   _.remove(
    //     state.cartItems,
    //     (cartItem) => cartItem.item.id === action.payload.id,
    //   );
    // },
    // clearCart: (state) => {
    //   state.cartItems = [];
    // },
  },
});

export const cartActions = cartSlice.actions;

export default cartSlice.reducer;
